import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Option, Response} from '../../../model/GeneralModels';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {GeneralService} from '../../../services/general.service';

@Component({
  selector: 'app-map-health-search',
  template: `
    <div class="factor elem">
      <div class="wrap" (clickOutside)="OnClickOutSide($event)" [delayClickOutsideInit]="true">
        <div class="row">
          <div class="col col-12">
            <div class="head">
              <i class="icon ico-shopping-cart-outline"></i>
              <h2>پرداخت حق بیمه</h2>
              <p>همین الان حق بیمه خودتون را پرداخت کنید</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col col-12">
            <app-select-field
              [fieldName]="'companyName'"
              [fieldLabel]="'شرکت'"
              [Group]="searchForm"
              [options]="companies"
              (OnChange)="getTypesList()"
            ></app-select-field>
            <app-select-field
              [fieldName]="'type'"
              [fieldLabel]="'نوع مرکز'"
              [Group]="searchForm"
              [options]="types"
            ></app-select-field>

            <app-input-field
              [disabled]="false"
              [Group]="searchForm"
              [fieldLabel]="'حد اکثر فاصله (کلومتر)'"
              [fieldName]="'distance'"
              [dataType]="['number']"
              [Icon]="true"
            ></app-input-field>
            <app-custom-button [HideMainButton]="false"
                               [disabled]="!searchForm.valid"
                               [Show]="true"
                               [LabelText]="'جست و جو'"
                               [BackButton]="false"
                               (OnClick)="search()"
            ></app-custom-button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class SearchComponent implements OnInit, OnChanges {
  @Input() showCondition = false;
  @Output() ClickOutSide = new EventEmitter<Event>();
  @Input() inProgress: boolean;
  @Input() longitude: number;
  @Input() latitude: number;
  @Output() locationsListChange = new EventEmitter<Option[]>();
  searchForm = this.fb.group({
    companyName: ['', Validators.required],
    stateName: [''],
    productName: ['HEALTH', Validators.required],
    type: [''],
    longitude: ['', Validators.required],
    latitude: ['', Validators.required],
    distance: ['10', Validators.required]
  });
  locations: any[] = [];
  companies: Option[] = [];
  states: Option[] = [];
  types: Option[] = [];
  constructor(private fb: FormBuilder,
              private service: HealthInsuranceService,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.generalService.getClientCompanyList('HEALTH').subscribe((response: Response) => {
      if (response.success) {
        response.data.forEach(company => {
          console.log(company);
          this.companies[this.companies.length] = new Option(company.label, company.value);
        });
        console.log(this.companies);
        if (this.companies.length === 1) {
          this.searchForm.controls.companyName.patchValue(this.companies[0].value);
          this.getTypesList();
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const list = ['latitude', 'longitude'];
    list.forEach(item => {
      if (!changes[item].firstChange && !changes[item].currentValue !== !changes[item].previousValue) {
        this.searchForm.controls[item].patchValue(changes[item].currentValue);
      }
    });
  }

  OnClickOutSide(event: Event) {
    console.log(event);
    if (this.showCondition === true) {
      this.ClickOutSide.emit(event);
    }
  }
  getTypesList() {
    if (this.searchForm.controls.companyName.valid) {
      this.generalService.getTypeList('HEALTH', this.searchForm.controls.companyName.value).subscribe(
        (response: Response) => {
          if (response.success) {
            this.types = response.data;
          }
        });
    }
  }

  search() {
    console.log(this.searchForm.value);
    if (this.searchForm.valid) {
      this.locations = [];
      this.generalService.searchNearMe(this.searchForm.value).subscribe((response: Response) => {
        if (response.success) {
          this.locations = response.data;
        }
        console.log(this.locations);
      });
    }
  }
  setLocation($event) {
    this.searchForm.controls.latitude.patchValue($event[0]);
    this.searchForm.controls.longitude.patchValue($event[1]);
  }
}
